import { render, staticRenderFns } from "./UploadFilesComponent.vue?vue&type=template&id=c3a302a2"
import script from "./UploadFilesComponent.vue?vue&type=script&lang=js"
export * from "./UploadFilesComponent.vue?vue&type=script&lang=js"
import style0 from "./UploadFilesComponent.vue?vue&type=style&index=0&id=c3a302a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports